<div *ngIf="loading | async" class="pz-loader-wrapper">
  <p-progressSpinner
    class="pz-loader"
    [style]="{ width: '50px', height: '50px' }"
    strokeWidth="4"
  ></p-progressSpinner>
</div>
